import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injector, Input, NgModule, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { WorkRole, WorkType } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'work-role-picker',
    templateUrl: './work.role.picker.component.html',
    styleUrls: ['./work.role.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: WorkRolePickerComponent, multi: true }
    ],
    standalone: false
})
export class WorkRolePickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: WorkRole[];
  @Input() public placeholder = '<Work Role>';
  @Input() public appendTo;
  @Input() public multiple: boolean;

  public data$: Observable<WorkRole[]>;
  public PickerItemStyle = PickerItemStyle;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges() {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.getWorkRoles()
      : of(this.data);

  }

  private getWorkRoles(): Observable<WorkRole[]> {
    return this.http.get<WorkRole[]>('/api/picker/work/roles');
  }
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule
  ],
  declarations: [
    WorkRolePickerComponent
  ],
  providers: [],
  exports: [
    WorkRolePickerComponent
  ],
})
export class WorkRolePickerModule { }
